import { Create, useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionGuard } from 'src/routes/components';
import { Resources } from '../resource';
import { DetailForm } from './DetailForm';
import { PERMISSION_RESOURCE } from './utils';

const CreateView = () => {
  const translate = useTranslate();

  return (
    <PermissionGuard resource={PERMISSION_RESOURCE} action="create" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('module.announcementPopup.title')}
          links={[
            {
              name: translate('module.announcementPopup.title'),
              href: `/${Resources.announcementPopup}`,
            },
            { name: translate('module.announcementPopup.create') || 'Create' },
          ]}
        />
        <Create resource={Resources.announcementPopup} redirect="list">
          <DetailForm />
        </Create>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default CreateView;
